module.exports = __webpack_public_path__ + "static/media/go-back-mobile.366d2cb1.svg";